<template>
    <button class="fin-btn" :class="`fin-btn-${this.type ? this.type : 'fin-btn-primary'}`" ref="finButton" type="button" :disabled="disabled" @click="click">
        <font-awesome-icon class="fin-mr-2" v-if="icons.iconLeft" :icon="icons.iconLeft" />
        <slot ref="finButtonSlot" />
        <font-awesome-icon class="fin-ml-2" v-if="icons.iconRight" :icon="icons.iconRight" />
    </button>
</template>

<script>
export default {
    name: "FinButton",
    props: {
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        type: {
            required: false,
            type: String,
            default: "primary",
        },
        icon: {
            required: false,
            type: [String, Boolean],
            default: false,
        },
        iconLeft: {
            required: false,
            type: [String, Boolean],
            default: false,
        },
        iconRight: {
            required: false,
            type: [String, Boolean],
            default: false,
        },
    },

    data() {
        return {}
    },

    computed: {
        icons() {
            return {
                iconLeft: this.iconLeft,
                iconRight: this.iconRight ? this.iconRight : this.icon
            }
        },
    },

    mounted() {},

    methods: {
        click() {
            this.$emit("click")
        },
    },

    watch: {

    },
}
</script>

<style lang="scss" scoped></style>
